import { Component, input, OnInit, output } from '@angular/core';

import { PrivaLocalizationModule } from '@priva/localization';

import { ManualFlowFooterComponent } from 'app/features/manual-input-registration/components';
import { AmountResultComponent, TerminalOverlayComponent } from 'app/shared/components';
import { Activity, ActivityType } from 'app/shared/features/activity-selector/models';

@Component({
    selector: 'app-manual-input-amount-result',
    templateUrl: './manual-input-amount-result.component.html',
    styleUrl: './manual-input-amount-result.component.scss',
    imports: [
        PrivaLocalizationModule,
        AmountResultComponent,
        ManualFlowFooterComponent,
        TerminalOverlayComponent,
    ],
})
export class ManualInputAmountResultComponent implements OnInit {
    title = input<string>('');
    activity = input<Activity | undefined>();
    activityType = input<ActivityType | undefined>();
    amountResult = input<number | undefined>();

    amountResultSelected = output<number>();
    closeRequested = output<void>();
    finishRequested = output<void>();

    amountResultInput: number | undefined;

    ngOnInit(): void {
        this.amountResultInput = this.amountResult();
    }

    onCloseRequested() {
        this.closeRequested.emit();
    }

    onAmountResultUpdated(amountResultUpdated: number | undefined) {
        if (this.amountResultInput !== amountResultUpdated) {
            this.amountResultInput = amountResultUpdated;
        }
    }

    onSelectionComplete() {
        if (this.amountResultInput !== undefined) this.amountResultSelected.emit(this.amountResultInput);
    }

    onFinishRequested(): void {
        this.finishRequested.emit();
    }
}
